exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.empty-information[data-v-e4f4815a] {\n  margin: auto;\n  text-align: center;\n  color: #505050;\n  padding-top: 5vmin;\n  padding-bottom: 5vmin;\n}\n.fixed-information[data-v-e4f4815a] {\n  border-bottom: 1px solid #dadada;\n}\n.fixed-information ul > li[data-v-e4f4815a]:last-child {\n  border: none;\n}\n.to_c_information[data-v-e4f4815a] {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
